export const WELCOME_PROMPT = 'ModalSources.WELCOME_PROMPT'
export const KEY_PRESSED = 'ModalSources.KEY_PRESSED'
export const CTA_BUTTON_CLICKED = 'ModalSources.CTA_BUTTON_CLICKED'
export const STOP_SKIPPED = 'ModalSources.STOP_SKIPPED'
export const TOUR_STARTED = 'ModalSources.TOUR_STARTED'

export default {
    WELCOME_PROMPT,
    KEY_PRESSED,
    CTA_BUTTON_CLICKED,
    STOP_SKIPPED,
    TOUR_STARTED,
}
